// Not window.posthog: RudderStack's PostHog integration stubs the methods of
// any client stored there
const APP_POSTHOG_CLIENT_KEY = Symbol.for('jb4.appPostHogClient');

export const setAppPostHogClient = client => {
  window[APP_POSTHOG_CLIENT_KEY] = client;
};

export const getAppPostHogClient = () =>
  typeof window === 'undefined' ? null : window[APP_POSTHOG_CLIENT_KEY] ?? null;
